export const flattenObj = (obj: object, prefix: string = ""): object => {
  if (prefix.length > 0 && !prefix.endsWith(".")) prefix = `${prefix}.`;
  if (obj)
    return Object.entries(obj).reduce((acc, [key, val]) => {
      const compositeKey = `${prefix}${key}`;
      if (typeof val === "object" && !Array.isArray(val))
        return { ...acc, ...flattenObj(val, compositeKey) };
      return { ...acc, [compositeKey]: val };
    }, {});
  return obj;
};
export const deepInsert = <T extends object>(
  obj: T,
  compositeKey: string,
  value: any
): T => {
  const splittedKey = compositeKey.split(".");
  if (splittedKey.length === 1) return { ...obj, [compositeKey]: value };
  const [prefix, ...others] = splittedKey;
  return {
    ...obj,
    [prefix]: deepInsert((obj as any)[prefix] ?? {}, others.join("."), value),
  };
};

export const fieldIsEmpty = (value: any): boolean => {
  if (value === undefined || value === null) return true;
  switch (typeof value) {
    case "object":
    case "string":
      if (value.length === 0) return true;
    case "number":
    default:
      return false;
  }
};
export const isAtLeastOneFilled = (arr: Array<any>) =>
  arr.length === 0 || arr.some((x) => !fieldIsEmpty(x));
export const deepGet = <T, F, K extends keyof F = keyof F>(
  entity: Partial<T>,
  key: K
) => (flattenObj(entity) as unknown as F)[key];
export const testOneKey = <T, F, K extends keyof F = keyof F>(
  entity: Partial<T>,
  key: K | Array<K>,
  deepGetFn: typeof deepGet = deepGet
) => {
  return Array.isArray(key)
    ? isAtLeastOneFilled(key.map((key) => deepGetFn<T, F, K>(entity, key)))
    : !fieldIsEmpty(deepGetFn<T, F, K>(entity, key));
};
export type GenericFieldError<P = string, E = string> = {
  property: P;
  error: E;
};
